import React, { useEffect, useContext, useState } from "react"
import { CaretDownIcon, CaretUpIcon, CheckIcon } from "@phosphor-icons/react"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react"
import clsx from "clsx"
import { getCurrencySymbol } from "@utils/utils"
import { StoreContext } from '@context/StoreContext'
import SearchBar from "@components/common/SearchBar"
import {useWindowSize} from "@components/helpers/useWindowSize"

import "country-flag-icons/1x1/flags.css"

const CountryDropdownButton = ({
	className = "dropdown-btn-style",
	caretSize = 20,
	optionListWidth = "min-w-20",
	options,
	onClick,
	noShadows = false,
}) => {
	const { width } = useWindowSize()
	const { currencySelected, setCurrencySelected } = useContext(StoreContext)
	const [searchText, setSearchText] = useState('')
	const [filteredList, setFilteredList] = useState(options)
	const isNotXL = width < 1280

	const handleSearch = (e) => {
		e.preventDefault()
		setSearchText(e.target.value)
	}

	useEffect(() => {
		setSearchText('')
		if(onClick) onClick(currencySelected)
	}, [currencySelected])

	useEffect(() => {
		let filtered
		if(searchText.trim() === '') 
			filtered = options
		else 
			filtered = options.filter(item => 
				item?.currencyCode?.toLowerCase().includes(searchText.toLowerCase()) ||
				item?.label?.toLowerCase().includes(searchText.toLowerCase())
			)
		setFilteredList(filtered)
	}, [searchText])

	if(!width) return

	return (
		<React.Fragment>
			<Menu as="div" className="relative">
				{({ open }) => (
					<>
						<MenuButton
							className={clsx('inline-flex w-max gap-x-1 md:gap-x-1.5', !noShadows && "shadow-sm", className)}
						>
							<div className="flex flex-nowrap gap-x-1.5 justify-between items-center w-full">
								<span className={clsx(`rounded-full text-lg`,`flag:${currencySelected?.countryCode}`)} />
								<span className="capitalize">
									{ isNotXL ? currencySelected?.currencyCode : currencySelected?.label }
								</span>
								<span>{`(${getCurrencySymbol(currencySelected?.currencyCode)?.symbol})`}</span>
								{open ? (
									<CaretUpIcon className="ml-2" size={caretSize} weight="light" />
								) : (
									<CaretDownIcon className="ml-2" size={caretSize} weight="light" />
								)}
							</div>
						</MenuButton>
						
						<MenuItems
							transition
							className={clsx(`absolute right-0 z-10 p-4 space-y-3 mt-2 origin-top-right text-black bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in`, optionListWidth)}
						>
							<div className="text-xs text-[#D1D1D1]">
								<p className="text-center font-medium !text-sm pb-2 text-black">Choose a currency</p>
								<SearchBar 
									value={searchText}
									onChange={handleSearch}
									placeHolder="Search"
									noBorders
								/>
							</div>
							<div className="overflow-y-scroll h-screen md:max-h-96 minimalist-scrollbar">
								{filteredList?.map((item) => {
									return (
										<MenuItem
											className="cursor-pointer hover:bg-slate-50/75 px-3 py-2 text-sm"
											key={`dp-${item?.countryCode}`}
											onClick={() => {
												setCurrencySelected(item)
											}}
										>
											<div className="flex gap-x-2 flex-nowrap ">
												<span className={clsx(`rounded-full text-lg`,`flag:${item?.countryCode}`)} />
												<div className="flex-1 flex gap-2">
													<span className="text-primary font-medium uppercase">{item?.currencyCode}</span>
													{/* <span>–</span> */}
													<span className="ml-1 text-secondary capitalize">{ item?.countryName }</span>
													{/* <span>{`${getCurrencySymbol(item.currencyCode)?.symbol}`}</span> */}
												</div>
												{currencySelected?.countryCode === item?.countryCode && (
													<CheckIcon className="text-success" size={18} />
												)}
											</div>
										</MenuItem>
									)
								})}
							</div>
						</MenuItems>
					</>
				)}

			</Menu>
		</React.Fragment>
	)
}

export default CountryDropdownButton